import { React, PT, withRouter, connect } from '@gasbuddy/react';
import { Segment, Input, Select, Button } from 'semantic-ui-react';
import { Action } from '../../reducers';
import { Auth, Nav, IdTable } from '../../components';

const searchOptions = [
  { key: 'email', text: 'Email', value: 'email' },
  { key: 'lastname', text: 'Last Name', value: 'lastname' },
  { key: 'id', text: 'Account Id', value: 'id' },
  { key: 'encid', text: 'Encrypted Account Id', value: 'encid' },
  { key: 'legacyid', text: 'Legacy Member Id', value: 'legacyid' },
  { key: 'cardname', text: 'Card Last Name', value: 'cardname' },
  { key: 'cardnumber', text: 'Card Number', value: 'cardnumber' },
  { key: 'lastfour', text: 'Card Last Four', value: 'lastfour' },
  { key: 'phone', text: 'Phone Number', value: 'phone' },
  { key: 'getupside', text: 'Get Upside Guid', value: 'get_upside' },
];

const pageSize = 25;

export class UsersBasePage extends React.Component {
  state = {
    text: '',
    type: 'email',
    offset: 0,
  }

  componentDidMount() {
    const { url, dispatch } = this.props;
    if (url) {
      dispatch({
        type: Action.Identity.Users.SearchRequested,
        meta: { apiAction: true },
        payload: {
          url,
          body: {},
        },
      });
    } else {
      this.searchBox.focus();
    }
  }

  setSearch = (event) => {
    this.setState({ text: event.target.value });
  }

  setType = (event, data) => {
    this.setState({ type: data.value });
  }

  keyPress = (e) => {
    if (e.key === 'Enter') {
      this.search();
    }
  }

  search = () => {
    const { dispatch } = this.props;
    const { text, type, offset } = this.state;
    dispatch({
      type: Action.Identity.Users.SearchRequested,
      meta: { apiAction: true },
      payload: {
        url: '/identity/users/lookup',
        body: {
          search: text,
          type,
          limit: pageSize + 1,
          offset,
        },
      },
    });
  }

  goAccount = (accountId) => {
    const { history } = this.props;
    history.push(`/identity/users/${accountId}`);
  }

  goPage(direction) {
    const { offset } = this.state;
    this.setState({
      offset: Math.max(0, offset + (pageSize * direction)),
    }, this.search);
  }

  render() {
    const { text, type, offset } = this.state;
    const { url, users } = this.props;

    return (
      <Auth forRoles="admin.superuser,admin.identity.users">
        <Nav>
          <div>
            {!url
              && (
              <Segment>
                <Input
                  fluid
                  action
                  defaultValue={text}
                  ref={(input) => { this.searchBox = input; }}
                  placeholder="Search by email or account id..."
                  onChange={this.setSearch}
                  onKeyPress={this.keyPress}
                >
                  <input />
                  <Select
                    scrolling
                    compact
                    options={searchOptions}
                    defaultValue={type}
                    onChange={this.setType}
                    style={{ width: '200px' }}
                  />
                  <Button onClick={this.search}>Search</Button>
                </Input>
              </Segment>
              )
            }

            <IdTable
              accounts={users.accounts}
              onSelected={this.goAccount}
              pageSize={pageSize}
              showPrevious={offset > 0}
              onNext={() => this.goPage(1)}
              onPrev={() => this.goPage(-1)}
              range={`Matches ${offset + 1}-${offset + pageSize}`}
            />
          </div>
        </Nav>
      </Auth>
    );
  }
}

UsersBasePage.propTypes = {
  dispatch: PT.func.isRequired,
  history: PT.shape({ push: PT.func.isRequired }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  users: PT.object.isRequired,
  url: PT.string,
};

UsersBasePage.defaultProps = {
  url: null,
};

export const UsersPage = withRouter(connect(({ users }) => ({ users }))(UsersBasePage));
